import { createAction, props } from '@ngrx/store';
import { EmailConnectionEntity } from '../../entities/email-connection.entity';

export const EmailConnectionActionTypes = {
    UpdateEmailConnections: createAction(
        'user/emailConnection/update',
        props<{ Payload: Array<EmailConnectionEntity> }>(),
    ),
    ModifyEmailConnection: createAction(
        'user/emailConnection/modify',
        props<{ Payload: EmailConnectionEntity; Payload2: string; hideDialog?: boolean }>(),
    ),
    AddEmailConnection: createAction(
        'user/emailConnection/add',
        props<{ Payload: EmailConnectionEntity; Payload2: string }>(),
    ),
    DeleteEmailConnection: createAction(
        'user/emailConnection/delete',
        props<{ Payload: number }>(),
    ),
};
